import Picker, { PickerValue } from 'react-mobile-picker'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import React, { useState } from 'react'
import Popup from './Popup'

interface TimePickerProps {
  time?: string
  defaultTime?: string
  onChange: (time: string) => void
  close?: basic.BasicFunc
}

const hours = Array.from(Array(24)).map((_, i) => String(i).padStart(2, '0'))
const minutes = Array.from(Array(60)).map((_, i) => String(i).padStart(2, '0'))

const TimePickerPopup: React.FC<TimePickerProps> = ({ time, defaultTime = '12:00', onChange, close: _close }) => {
  const [timeValue, setTimeValue] = useState<PickerValue>(() => {
    const [hour, minute] = time ? time.split(':') : defaultTime.split(':')
    return { hour, minute }
  })

  const { goBack } = useHistory()
  const { t } = useTranslation('form')
  const close = _close || goBack

  return (
    <Popup
      save={() => {
        onChange(`${timeValue.hour}:${timeValue.minute}`)
        close()
      }}
      close={_close}>
      <div className='popup__main__time'>
        <div className='popup__main__time__header'>
          <span>{t('hour')}</span>
          <span>{t('minute')}</span>
        </div>

        <Picker
          value={timeValue}
          wheelMode='natural'
          className='timePicker'
          onChange={(newValue) => {
            setTimeValue(newValue)
          }}>

          <Picker.Column name='hour'>
            {hours.map((hour) => (
              <Picker.Item
                key={hour}
                value={hour}>
                {({ selected }) => <div className={`timePicker__option --secFont ${selected ? ' --selected' : ''}`}>{hour}</div>}
              </Picker.Item>))}
          </Picker.Column>

          <Picker.Column name='minute'>
            {minutes.map((minute) => (
              <Picker.Item
                key={minute}
                value={minute}>
                {({ selected }) => <div className={`timePicker__option --secFont ${selected ? ' --selected' : ''}`}>{minute}</div>}
              </Picker.Item>))}
          </Picker.Column>
        </Picker>
      </div>
    </Popup>
  )
}

export default TimePickerPopup